<template>
	<div class="conten">
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input clearable v-model="secah.supplierName" placeholder="请输入供货商名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click='secahClick'>搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click='add'>新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<div>
			<el-table :data="tableData" style="width: 100%" border>
				<el-table-column prop="supplierName" label="供货商名称" align="center">
				</el-table-column>
				<el-table-column prop="continuedWeightPrice" label="续重金额" align="center">
				</el-table-column>
				<el-table-column prop="continuedWeightType" label="续重方式" align="center">
					<template slot-scope="scope">
						{{scope.row.continuedWeightType==1?"按公斤":"按斤"}}						
					</template>
				</el-table-column>
				<el-table-column prop="firstWeight" label="首重" align="center">
				</el-table-column>
				<el-table-column prop="firstWeightPrice" label="首重金额" align="center">
				</el-table-column>
				<el-table-column prop="supplierFreePostage" label="免邮费积分" align="center">
				</el-table-column>
				<el-table-column prop="refundFreight" label="退款退货运费" align="center">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="150" align="center">
					<template slot-scope="scope">
						<el-button size="mini" @click="edit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>						
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="secah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="secah.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
		<el-dialog :close-on-click-modal='false' :close-on-press-escape='false' :title="isAdd?'新增':'修改'" :visible.sync="dialogVisible" :modal-append-to-body='false' width="600px">
			<el-form :model="form">
				
				<el-form-item label="供货商名称" label-width='140px'>
					<el-input v-model="form.supplierName" maxlength="10" autocomplete="off" placeholder="请输入供货商名称"></el-input>
				</el-form-item>
				<el-form-item label="续重金额" label-width='140px'>
					<el-input v-model="form.continuedWeightPrice" maxlength="18" autocomplete="off" placeholder="请输入续重金额"></el-input>
				</el-form-item>
				<el-form-item label="续重方式" label-width='140px'>
					<el-select v-model="form.continuedWeightType" placeholder="请选择">
						<el-option  label="按公斤" :value="1">
						</el-option>
						<el-option  label="按斤" :value="2">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="首重" label-width='140px'>
					<el-input v-model="form.firstWeight" maxlength="18" autocomplete="off" placeholder="请输入首重"></el-input>
				</el-form-item>
				<el-form-item label="首重金额" label-width='140px'>
					<el-input v-model="form.firstWeightPrice" maxlength="18" autocomplete="off" placeholder="请输入首重金额"></el-input>
				</el-form-item>
				<el-form-item label="免邮费积分" label-width='140px'>
					<el-input v-model.number="form.supplierFreePostage" maxlength="18" autocomplete="off" placeholder="请输入免邮费积分"></el-input>
				</el-form-item>
				<el-form-item label="退款退货运费" label-width='140px'>
					<el-input v-model.number="form.refundFreight" maxlength="18" autocomplete="off" placeholder="请输入退款退货运费"></el-input>
				</el-form-item>
			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="sub">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [],
				total: 0,
				dialogVisible: false,
				isAdd: true,
				secah: {
					pageSize: 10,
					pageNum: 1,
					supplierName: ""
				},
				form: {
					continuedWeightPrice:'' ,
					continuedWeightType:'',
					firstWeight: '',
					firstWeightPrice: '',
					supplierFreePostage: '',
					supplierId: '',
					supplierName: "",
					refundFreight:0
				},

			}
		},
		created() {
			this.getSupplierList()
		},
		methods: {
			//搜索
			secahClick() {
				this.secah.pageNum = 1
				this.getSupplierList()
			},
			//新增
			add() {
				this.dialogVisible = true
				this.isAdd = true
				this.form={
					continuedWeightPrice:'' ,
					continuedWeightType:'',
					firstWeight: '',
					firstWeightPrice: '',
					supplierFreePostage: '',
					supplierId: '',
					supplierName: "",
					refundFreight:0
				}
			},
			//提交
			sub(){
				if (this.form.supplierName.length == 0) {
					this.$message('请输入供货商名称');
					return false
				}
				if (this.form.continuedWeightPrice.length == 0) {
					this.$message('请输入续重金额');
					return false
				}
				if (!this.istwoNum(this.form.continuedWeightPrice)) {
					this.$message('请输入大于0的整数或者保留两位小数的续重金额');
					return false
				}
				this.form.continuedWeightPrice=parseFloat(this.form.continuedWeightPrice)
				if (this.form.continuedWeightType.length == 0) {
					this.$message('请输入选择续重方式');
					return false
				}
				if (this.form.firstWeight.length == 0) {
					this.$message('请输入首重');
					return false
				}			
				if (!this.istwoNum(this.form.firstWeight)) {
					this.$message('请输入大于0的整数或者保留两位小数的首重');
					return false
				}
				this.form.firstWeight=parseFloat(this.form.firstWeight)
				if (this.form.firstWeightPrice.length == 0) {
					this.$message('请输入首重金额');
					return false
				}				
				if (!this.istwoNum(this.form.firstWeightPrice)) {
					this.$message('请输入大于0的整数或者保留两位小数的首重金额');
					return false
				}
				this.form.firstWeightPrice=parseFloat(this.form.firstWeightPrice)
				if (this.form.supplierFreePostage.length == 0) {
					this.$message('请输入免邮费积分');
					return false
				}
				if (this.form.supplierFreePostage === 0) {
					this.$message('请输入正确的积分，积分为大于0的正整数');
					return false
				}
				if (!this.isNum(this.form.supplierFreePostage)) {
					this.$message('请输入正确的积分，积分为大于0的正整数');
					return false
				}
				if (this.form.refundFreight.length == 0) {
					this.$message('请输入退款退货运费');
					return false
				}
				if (!this.istwoNum(this.form.refundFreight)) {
					this.$message('请输入大于0的整数或者保留两位小数的退款退货运费');
					return false
				}
				
				var url=this.isAdd?"/supplier/add":"/supplier/update"
				if(this.isAdd){
					this.httpPost(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						console.log(res)
						if (res.code == 200) {
							this.$message.success('新增成功');
							this.dialogVisible = false
							this.getSupplierList()
						}
					})
				}else{
					this.httpPut(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						console.log(res)
						if (res.code == 200) {
							this.$message.success('修改成功');
							this.dialogVisible = false
							this.getSupplierList()
						}
					})
				}
				
			},
			
			//删除
			del(row) {
				console.log(row);
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.httpDel("/supplier/del?"+this.$qs.stringify({supplierId:row.supplierId})).then(res => {
						if (res.code == 200) {
							this.$message.success('删除成功');
							this.getSupplierList()
						}
					})
				}).catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '已取消删除'
					// });
				});
			},
			//修改
			edit(row) {
				console.log(row);
				this.dialogVisible = true
				this.isAdd = false
				this.form=JSON.parse(JSON.stringify(row))
				// this.form.password=''
				
			},

			//选择分页条数
			handleSizeChange(e) {
				this.secah.pageNum = 1
				this.secah.pageSize = e
				this.getSupplierList()
			},
			//页码
			handleCurrentChange(e) {
				this.secah.pageNum = e
				this.getSupplierList()
			},
			//获取数据
			getSupplierList() {
				this.httpPost("/supplier/listByPage", this.secah, true, {
					'Content-Type': 'application/json'
				}).then(res => {
					console.log(res)
					if (res.code == 200) {
						this.tableData = res.data.content
						this.total = res.data.total
					}
				})

			},
			

		},


	}
</script>

<style scoped lang='scss'>
	.page {
		padding: 20px 0;
	}
</style>
